<template>
	<div class="row justify-content-center">
		<div class="col-lg-10 mt-5">
			<form @submit.prevent="submitForm">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<h1 class="fs-1-5">In quest’area puoi personalizzare un pacchetto per la classe {{className}}</h1>
					</div>
					<div class="col-xl-10">
						<hr class="fv-hr my-4">
					</div>
				</div>
				<div class="row align-items-center justify-content-center">
					<div class="col-12 text-center mb-3">
						<h2 class="fs-2-3 mt-2">Scrivi qui la tua frase</h2>
						<p class="text-center">
							• La lunghezza non può essere superiore a 100 caratteri spazi inclusi<br>
							• Verifica che nulla di quanto scritto violi la privacy di qualcuno e sia conforme al <a :href="urlTheme + '/pdf/regolamento-fumo-e-altre-stories.pdf'" target="_blank">Regolamento</a>
						</p>
					</div>
					<div class="col-lg-10 col-xl-8 form-group mb-2">
						<input type="text" name="title" id="title" class="form-control form-control-lg" placeholder="La tua frase*" required autocomplete="aut_off_iuasdsvkz" maxlength="100" v-model="form.title" :didabled="isDisabled">
					</div>
					<div class="col-lg-10 col-xl-8 text-right"><small>Max 100 caratteri</small></div>

					<div class="col-xxl-10 text-center mt-2">
						<div class="fs-1-2" v-html="formMsg"></div>
					</div>

					<div class="col-12 text-center mt-3 mb-3" v-if="btnText">
						<button type="submit" id="sub-work" class="btn btn-blk rounded-pill btn-lg px-5 py-3 va-m" value="INVIA" :disabled="isDisabled"><span>{{btnText}}</span> <i class="fas fa-cog fs-1-5 fa-spin ml-2 mt-1" :class="{'d-none': loaderIsHidden}"></i></button>
					</div>
				</div>
			</form>

			<div class="row">
				<div class="col-12 mt-5 mb-4 text-center text-lg-left">
					<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-arrow-left-square cursor-p" viewBox="0 0 16 16" @click.prevent="closeForm" style="cursor:pointer;">
						<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm11.5 5.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
					</svg>
					<span class="ml-2 bold">Torna indietro</span>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
const jQuery = window.jQuery
import axios from 'axios'

export default {
	name: 'WorkFormTextComponent',
	props: ['idClass', 'idWork', 'className', 'urlTheme'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			form: {
				title: '',
				prevIdWork: 0,
				idWork: 0
			},
			formMsg: '',
			btnText: 'CONFERMA E CARICA',
			isDisabled: false,
			loaderIsHidden: true
		}
	},

	methods: {
		getPreviousTextyData() {
			let self = this

			if(this.form.idWork != 0 && this.form.idWork != '') {
				let formData = new FormData()
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
				formData.append('action', 'nl_get_previous_text_data')
				formData.append('workID', this.form.idWork)
				formData.append('classID', this.idClass)

				axios.post( this.ajaxObj.ajax_url,
					formData
				)
				.then(function(response){
					// console.log(response.data)
					self.form.title = response.data.db.text
					self.form.prevIdWork = response.data.db.id

					if(response.data.db.active == 0) {
						self.btnText = 'MODIFICA'
					} else {
						self.btnText = ''
					}
				})
				.catch(function(error) {
					console.log(error)
				});
			}
		},

		submitForm() {
			let url = this.ajaxObj.ajax_url

			this.loaderIsHidden = false
			this.isDisabled = true
			this.formMsg = ''

			let formData = new FormData();
			formData.append('action', 'nl_upload_work_text')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('classID', this.idClass)
			formData.append('workID', this.form.idWork)
			formData.append('prevIdWork', this.form.prevIdWork)
			formData.append('title', this.form.title)

			axios.post(url, formData)
				.then((response) => {
					// console.log(response.data)
					this.loaderIsHidden = true
					if(response.data.error == '') {
						this.formMsg = response.data.msg
						this.form.prevIdWork = response.data.id_work
						this.form.idWork = response.data.id_work
						this.btnText = this.form.idWork > 0 ? 'MODIFICA' : 'CONFERMA E CARICA'
						this.isDisabled = false
					} else {
						this.formMsg = '<span class="txt-error">' + response.data.error + '</span>'
						this.isDisabled = false
					}
				}, (error) => {
					this.isDisabled = false
					this.loaderIsHidden = true
					console.log(error);
				});
		},

		closeForm() {
			this.$emit('closeWrkForm')
		}
	},

	mounted() {
		jQuery(window).scrollTop(0);
		jQuery('.form-work-open').addClass('d-none')
		/*jQuery('#intro-text').addClass('d-none')
		jQuery('#intro-text-1').addClass('d-none')
		jQuery('#school-message').addClass('d-none')
		jQuery('#welcome-text').text('Personalizza il tuo pacchetto')
		jQuery('#download_area_privata').addClass('d-none')*/
		this.form.idWork = this.idWork

		if(this.idWork != "0") {
			this.getPreviousTextyData()
		}
	}
}
</script>

<style scoped>
	.fas.fa-cog {
		vertical-align: text-bottom;
		opacity: .9;
	}
	.cursor-p {
		cursor: pointer;
		transition: all .2s ease-in-out;
	}
	.cursor-p:hover, .cursor-p:focus {
		color: #999;
	}
	.checkbox-custom+.checkbox-custom-label:before {
		margin-right: 0;
	}
</style>
